<template>
  <div class="container-fluid d-flex flex-column flex-grow-1">
    <div class="d-flex align-items-center">
      <h2 class="page-heading mr-auto">Мои выборки</h2>
    </div>

    <div class="table-full-width flex-grow-1 bg-white d-flex flex-column">
      <table class="table mb-0">
        <thead>
        <tr><th>
          <span class="mr-3" style="min-width: 2em">№</span>
          <span>Выборки</span>
        </th></tr>
        </thead>
      </table>

      <height-tracker class="container-fluid flex-grow-1">
        <div class="table-full-width" slot-scope="{ height }">
          <div ref='content' :style="'overflow-y: auto; height: ' + height + 'px'">
            <draggable v-model="currentSamples">
              <div v-for="(element, index) in currentSamples" class="cursor-pointer" @click="useSample(element)" @touchstart="useSample(element)">
                <div class="d-flex flex-row p-2 washy-bottom">
                  <div class="mr-3" style="min-width: 2em">{{index + 1}}</div>
                  <div>{{element.name}}</div>
                  <div class="ml-auto text-nowrap">
                    <button @click.stop="edit(element)" class="btn btn-sm btn-outline-light">Редактировать</button>
                    <btn-action @click.stop="() => remove(element)" class="btn btn-sm btn-outline-light">Удалить</btn-action>
                  </div>
                </div>
              </div>
            </draggable>
            <slot/>
          </div>
        </div>
      </height-tracker>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import api from '@/api'
  import sampleModal from '../../components/sample-modal-edit.vue'
  import { encode } from '../../query-encoder'

  export default {
    metaInfo: {title: 'Мои выборки'},
    components: {
      draggable,
    },
    data () {
      return {
        currentSamples: null,
        moving: null,
      }
    },
    methods: {
      edit (sample, event) {
        this.$root.showModal(sampleModal, {
          id: sample.id,
          name: sample.name,
        }).then((data) => {
          if (data !== undefined) {
            let element = this.currentSamples.find((current) => current.id === sample.id)
            if (element !== undefined) {
              Object.assign(element, data)
            }
          }
        })
      },
      remove (element, event) {
        if (!window.confirm('Подтвердить удаление?')) return

        return api.delete('samples/' + element.id).then(() => {
          this.currentSamples.splice(this.currentSamples.indexOf(element), 1)
        })
      },
      useSample (sample) {
        let path = this.$router.resolve(sample.path + '?filters=' + encode(sample.filters))
        window.open(path.href, '_blank');
      }
    },
    watch: {
      currentSamples (list) {
        if (list !== undefined) {
          api.post('samples/order', {
            ids: Array.map(list, (current) => current.id),
          })
        }
      },
    },
    asyncComputed: {
      elements () {
        api.get('samples').then(({data}) => {
          this.currentSamples = data.data
        })
      },
    },
  }
</script>

<style lang="scss">
  .washy-bottom {
    border-bottom: 1px solid #F7FAFB;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/samples.vue